import Vue from 'vue'
import store from '~/store'
import router from '~/router/index_apo_one'
import AppApoOne from '~/components/AppApoOne'
import { i18n } from '~/plugins/i18n'
import Notifications from 'vue-notification'
import VueMask from 'v-mask'
import VueLocalStorage from 'vue-localstorage'

import '~/plugins/axios'
import '~/plugins/fontawesomeApoOne'
import '~/plugins/navigation'
import '~/plugins/bootstrap'
import '~/filters'
import '~/components/index_apo_one'

Vue.config.productionTip = false

Vue.use(Notifications)
Vue.use(VueMask)
Vue.use(VueLocalStorage)

new Vue({
  i18n,
  store,
  router,
  ...AppApoOne
})